import {Fragment, useState} from 'react';

import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {useDataTableBasic} from '../../../shared/hooks/DataTableBasic';
import {XlsxService} from '../../../service/XlsxService';
import {ToastService} from '../../../AppToast';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {localized, useTranslation} from '../../../shared/language';

import {TaxCodeService} from './TaxCodeService';

export default function TrangThaiMst() {
  const {t} = useTranslation();

  const [taxCode, setTaxCode] = useState('');

  const [info, setInfo] = useState({});

  const [items, setItems] = useState(null);

  const searchOne = () => {
    getOrgInfo(taxCode).then(data => {
      setItems([data]);
    });
  }

  const searchMany = async values => {
    const keys = {};
    values.forEach(value => {
      keys[value || ''] = true;
    });
    for (const k of Object.keys(keys)) {
      await getOrgInfo(k);
    }
    const complete = [];
    values.forEach(value => {
      complete.push(getOrgInfo(value || ''));
    });
    Promise.all(complete).then(results => {
      setItems(results);
    });
  }

  const validateTaxCode = value => {
    let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
    if (value.length > 10) {
      patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
    }
    if (value === "") return true;
    if (patt.test(value) === false) {
      return false;
    }
    const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
      + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
      + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

    return (10 - number % 11) === Number(value.charAt(9));
  }

  const getOrgInfo = input => {
    input = `${input}`.trim();
    return new Promise(resolve => {
      if (input && validateTaxCode(input)) {

        if (info[input]) {
          resolve(info[input]);
        } else {
          TaxCodeService.get(input).then(data => {
            if (data?.ma_so_thue) {

              setInfo(prevInfo => {
                prevInfo[input] = data;
                return prevInfo;
              });

              resolve(data);
            } else {
                resolve({ten_tthai: t('validation.taxStatusNotFound'), ma_so_thue: input});
            }
          });
        }
      } else {
        resolve({ten_tthai: t('validation.taxCodeInvalid'), ma_so_thue: input});
      }
    });
  }

  const getClassName = tthai => {
    let className = 'alert-warning';
    switch (tthai) {
      case '00':
        className = 'alert-success';
        break;
      case '01':
      case '03':
        className = 'alert-error';
        break;
      case '05':
      case '06':
        className = 'alert-danger';
        break;
    }
    return className;
  }

  const {render: renderUpload, update: upload} = useDialogCrup({
    header: t('common.upload') + ' Excel',
    width: '40rem',
    fields: [
      {field: 'file', header: t('common.chooseFile'), required: true, type: 'file', InputFileProps: {accept: '.xlsx, .xls'}, className: 'md:col-12 mb-1'},
      {field: 'colIndex', header: t('common.columnName'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-12'},
      {field: 'startRow', header: t('common.startRow'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-12'}
    ],
    createItem: item => {
      const {file, colIndex, startRow} = item;

      return new Promise<any>((resolve, reject) => {
        XlsxService.readExcelFile(file, {startRow: startRow - 1}).then(data => {
          const values = [];
          if (data?.length) {
            data.forEach(row => {
              if (row[colIndex - 1]) {
                values.push(row[colIndex - 1]);
              }
            });
          }
          if (values.length) {
            resolve(values);
          } else {
            ToastService.error(localized('common.empty'));
            reject(t('common.empty'));
          }
        });
      });
    },
    refreshLazyData(data?: any) {
      searchMany(data).then();
    }
  });

  const {render} = useDataTableBasic({
    header: `${items?.length || 0} ${t('common.taxCode')}`,
    columns: [
      {
        field: 'ten_tthai', header: t('common.status'), minWidth: 150, dataType: 'custom', customCell(rowData: any): any {
          return <span className={getClassName(rowData.tthai)}>{rowData.ten_tthai}</span>
        }
      },
      {field: 'ma_so_thue', header: t('common.taxCode'), width: 140},
      {field: 'ten_cty', header: t('common.entityName'), minWidth: 150},
      {field: 'dia_chi', header: t('common.address'), minWidth: 150},
      {field: 'cqthue_ql', header: t('system.managingTaxAuthority'), minWidth: 150}
    ],
    items
  });

  const exportExcel = () => {
    if (items?.length) {
      const aoa = [];
      aoa.push([t('common.status'), t('common.taxCode'), t('common.entityName'), t('common.address'), t('system.managingTaxAuthority')]);
      items.forEach(item => {
        aoa.push([item.ten_tthai, item.ma_so_thue, item.ten_cty, item.dia_chi, item.cqthue_ql]);
      });
      XlsxService.generateFile(aoa, 'tinh-trang-mst');
    } else {
      ToastService.error(localized('common.empty'));
    }
  }

  return (
    <Fragment>
      <div className="grid">
        <div className="col-3 p-fluid">
          <InputText value={taxCode} onChange={e => setTaxCode(e.target.value)} placeholder={t('common.enterTaxCode')}/>
        </div>
        <div className="col-1">
          <Button icon="pi pi-search" label={t('common.search')} onClick={searchOne} className="p-button-outlined"/>
        </div>
        <div className="col-8 text-right">
          <Button icon="pi pi-file-excel" label={t('common.searchMultipleTaxCodes')} onClick={() => upload({colIndex: 6, startRow: 7})} className="p-button-outlined p-button-help mr-2"/>
          <Button icon="pi pi-download" label={t('common.exportSearchResults')} onClick={exportExcel} className="p-button-outlined"/>
        </div>
      </div>
      <div className="grid mt-2">
        <div className="col-12">
          {render()}
        </div>
      </div>

      {renderUpload()}
    </Fragment>
  );
}
